import { opaccAjaxPlugin } from '../opacc.static.js';

/** @module manager */

/**
 *  Session TimeOut ausführen.
 */
export class OpaccSession {
    constructor() {
        this.initSessionTimeout();
        this.sessionKeepAlive();
    }

    /**
     *
     */
    initSessionTimeout() {
        this.sessionTimeOutContainer = document.querySelector('.opc-manager-session-timeout');
        this.sessionTimeOut = undefined;

        if(this.sessionTimeOutContainer) {
            this.showSessionTimeoutMessage();
        }
    }

    /**
     *
     */
    showSessionTimeoutMessage() {
        if(this.sessionTimeOutContainer.dataset.opTimeout !== undefined && this.sessionTimeOutContainer.dataset.opTimeout !== "") {
            this.sessionTimeOut = Number(this.sessionTimeOutContainer.dataset.opTimeout);
            setTimeout(() => {
                let bodyTag = document.querySelector("body");
                if(bodyTag) {
                    bodyTag.classList.add('session-timeout-message-active');
                }
            }, this.sessionTimeOut);
        }
    }

    sessionKeepAlive() {
        let sessionTimeout = document.querySelector('html[data-op-timeout]');

        if (!sessionTimeout) {
            return;
        }

        setInterval(() => {
            opaccAjaxPlugin.fetchAsynGetForm(window.location.origin, this.sessionKeepAliveCB(), this.getDefaultErrorFnc, true);
        }, +sessionTimeout.dataset.opTimeout*0.75 );
    }

    sessionKeepAliveCB() {}
}